import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './authSlice';
import uiReducer from './uiSlice';
import tradeReducer from './tradeSlice';
import adminReducer from './adminSlice';

// Persist auth (user, token, AND impersonation state)
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token', 'isAuthenticated', 'isImpersonating', 'adminUser', 'adminToken']
};

// Persist admin (admin user and token)
const adminPersistConfig = {
  key: 'admin',
  storage,
  whitelist: ['isAdminAuthenticated', 'adminToken', 'adminUser', 'adminPermissions']
};

// Persist only UI preferences (theme, sidebar state) - NOT financial data
const uiPersistConfig = {
  key: 'ui',
  storage,
  whitelist: ['theme', 'sidebarOpen', 'sidebarTab', 'sidebarCat', 'favorites', 'chartType', 'lotSize', 'maxLot', 'leverage', 'activeInstrument']
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  admin: persistReducer(adminPersistConfig, adminReducer),
  ui: persistReducer(uiPersistConfig, uiReducer),
  trade: tradeReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);